import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"

import "./About.vue?vue&type=style&index=0&id=609c3150&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609c3150"]])

export default __exports__